import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";

import { useAppSelector } from "../../../store/reducers";
import { Filter, IProps as IFilterProps } from "../Filter";
import { defaultState } from "../defaults";

import styles from "./index.module.scss";

type IProps = Immutable<
    IFilterProps & {
        isMobile: boolean;
    }
>;

export const TopFilterSection = (props: IProps) => {
    const facets = useAppSelector(
        (state) => (state.reviews || defaultState).data.facets,
    );

    const filterClasses = classNames({
        [styles.topFilters]: true,
    });
    return (
        <div className={filterClasses}>
            {facets.map((facet) => (
                <Filter {...props} key={facet.type} facet={facet} />
            ))}
        </div>
    );
};
